import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import BottomNav from "@/components/BottomNav";
import Footer from "@/components/Footer";
import { OnboardingProvider } from "@/components/Onboarding";
import VerifyEmailSheet from "@/components/VerifyEmailSheet";
import VerifyEmailBanner from "@/components/VerifyEmailBanner";

export default function Layout() {
  const loc = useLocation();
  const hideNav = loc.pathname === "/login" || loc.pathname === "/registar" || loc.pathname === "/esqueci" || loc.pathname.startsWith("/reset-password");
  return (
    <OnboardingProvider>
    <div className="App min-h-screen bg-[#fafafa] flex flex-col">
      {!hideNav && <Header />}
      {!hideNav && <VerifyEmailBanner />}
      <VerifyEmailSheet />
      <main className="pt-2 flex-1">
        <Outlet />
      </main>
      {!hideNav && <Footer />}
      {!hideNav && <BottomNav />}
    </div>
    </OnboardingProvider>
  );
}
